import styled from 'styled-components';
import { CommonButton } from '../../common/CommonButton';
import { useTextVariant } from '../../../hook/useTextVariant';
import { WARING_MODAL_CONSTANTS, SATELLITE_ITEMS, MAIN_EVENT_ITEMS } from '../../../constants/waringModal';
import { WaringModalViewProps } from '../WaringModal';

export const WaringModalMobile = ({ visible = false, close }: WaringModalViewProps) => {
  const { getText } = useTextVariant(WARING_MODAL_CONSTANTS, true);

  return (
    <ModalWrap $visible={visible}>
      <Dim />
      <ModalContent $visible={visible}>
        <Title>{getText('title')}</Title>
        <Content>
          <ContentTitle>{getText('satelliteTitle')}</ContentTitle>
          <Inner>
            {SATELLITE_ITEMS.map((item, i) => (
              <ContentListItem key={i}>{item}</ContentListItem>
            ))}
          </Inner>
          <ContentTitle>{getText('mainEventTitle')}</ContentTitle>
          {MAIN_EVENT_ITEMS.map((item, i) => (
            <ContentListItem key={i}>{item}</ContentListItem>
          ))}
        </Content>
        <ButtonContainer onClick={close}>
          <CommonButton text={getText('confirmBtn') as string} />
        </ButtonContainer>
      </ModalContent>
    </ModalWrap>
  );
};

const ButtonContainer = styled.div`
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;

  button {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
  }
`;

const ModalWrap = styled.div<{ $visible: boolean }>`
  visibility: ${({ $visible }) => ($visible ? 'visible' : 'hidden')};
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10000000;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Dim = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
`;

const ModalContent = styled.div<{ $visible: boolean }>`
  max-width: 90%;
  background: #302e2d;
  box-shadow: 0px 1px 1px 0px rgba(255, 255, 255, 0.2) inset;
  position: relative;
  z-index: 2;
  transform: ${({ $visible }) => ($visible ? 'scale(1)' : 'scale(0.75)')};
  transition: transform 0.15s ease-in-out;
  border-radius: 20px 20px 0px 0px;
  padding: 25px 15px 15px 15px;
  padding-bottom: 0;
  overflow-y: auto;
  height: 500px;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
`;

const ContentTitle = styled.h3`
  color: rgba(255, 255, 255, 0.8);
  font-size: 13px;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: -1.04px;
  margin-bottom: 20px;
`;

const Content = styled.ul`
  border-radius: 8px;
  background: #201f1e;
  padding: 20px 10px;
  list-style: none;
  display: flex;
  flex-direction: column;
  height: 360px;
  overflow-y: auto;
`;

const Inner = styled.div`
  margin-bottom: 30px;
`;

const ContentListItem = styled.li`
  color: #b2b2b2;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: -0.39px;
  margin-bottom: 5px;
  position: relative;
  padding-left: 10px;

  &:after {
    content: '';
    width: 3px;
    height: 3px;
    position: absolute;
    background-color: #b2b2b2;
    top: 5px;
    left: 0;
    border-radius: 50%;
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

const Title = styled.h3`
  color: #fbf6d5;
  text-align: center;
  font-size: 15px;
  font-weight: 600;
`;
